import { NavLink, useLocation } from "react-router-dom";
import SideBarLink from "./SideBarLink";
import {
  AdminSettingsSvg,
  ChevronDown,
  Contractsvg,
  Dashboardsvg,
  FinecialSvg,
  HourlySvg,
  LeaveManagement,
  Manageapplication,
  Manageroletab,
  NoteSvg,
  NotificationSvg,
  PrintSvg,
  ReportReciptSvg,
  ReportsSvg,
  ReportTaxReport,
  StatsSvg,
  SuportSvg,
  Vendororder,
} from "../SvgFile/Index";
import { useEffect, useRef, useState } from "react";
import Logout from "../Component/Pages/Auth/Logout";

export default function Sidebar() {
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState("");
  const [links, setLinks] = useState([]);
  const user = JSON.parse(localStorage.getItem("userData"));
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState("");

  const handleClose = () => {
    setOpen(false);
  };

  const member_links = [
    {
      url: "/projects",
      roleName: "Manage Projects",
      icon: <Vendororder />,
    },
    {
      url: "/task",
      roleName: "Manage Tasks",
      icon: <PrintSvg />,
    },
    {
      url: "/activitylog",
      roleName: "Activity Logs",
      icon: <ReportTaxReport />,
    },
    {
      url: "/notification",
      roleName: "Notifications",
      icon: <NotificationSvg />,
    },

    {
      url: "/note",
      roleName: "My Notes",
      icon: <NoteSvg />,
    },
    {
      url: "/support",
      roleName: "Hardware Support",
      icon: <SuportSvg />,
    },
  ];

  const manager_links = [
    {
      url: "/projects",
      roleName: "Manage Projects",
      icon: <Vendororder />,
    },
    {
      url: "/task",
      roleName: "Manage Tasks",
      icon: <PrintSvg />,
    },
    // {
    //   url: "/estimation",
    //   roleName: "Manage Estimations",
    //   icon: <ReportOrderReport />,
    // },
    {
      url: "/activitylog",
      roleName: "Activity Logs",
      icon: <ReportTaxReport />,
    },
    {
      url: "/notification",
      roleName: "Notifications",
      icon: <NotificationSvg />,
    },

    {
      url: "/note",
      roleName: "My Notes",
      icon: <NoteSvg />,
    },
    {
      url: "/support",
      roleName: "Hardware Support",
      icon: <SuportSvg />,
    },
  ];

  const adminmanager_links = [
    {
      url: "/client",
      roleName: "Manage Clients",
      icon: <ReportReciptSvg />,
    },

    {
      url: "/projects",
      roleName: "Manage Projects",
      icon: <Vendororder />,
    },
    {
      url: "/task",
      roleName: "Manage Tasks",
      icon: <PrintSvg />,
    },

    {
      url: "/stats",
      roleName: "Projects Stats",
      icon: <StatsSvg />,
    },

    {
      roleName: "Reports",
      icon: <ReportsSvg />,
      children: [
        {
          url: "/hourly-report",
          roleName: "Hourly Report",
          icon: <HourlySvg />,
        },
        {
          url: "/financial-report",
          roleName: "Finance Report",
          icon: <FinecialSvg />,
        },
      ],
    },

    // {
    //   url: "/estimation",
    //   roleName: "Manage Estimations",
    //   icon: <ReportOrderReport />,
    // },
    {
      url: "/activitylog",
      roleName: "Activity Logs",
      icon: <ReportTaxReport />,
    },
    {
      url: "/notification",
      roleName: "Notifications",
      icon: <NotificationSvg />,
    },
    {
      url: "/count",
      roleName: "Current Team's Status",
      icon: <PrintSvg />,
    },

    {
      url: "/note",
      roleName: "My Notes",
      icon: <NoteSvg />,
    },
    {
      url: "/support",
      roleName: "Hardware Support",
      icon: <SuportSvg />,
    },
  ];

  const admin_links = [
    {
      url: "/stats",
      roleName: "Projects Stats",
      icon: <StatsSvg />,
    },
    {
      url: "/count",
      roleName: "Current Team's Status",
      icon: <PrintSvg />,
    },
    {
      url: "/projects",
      roleName: "Manage Projects",
      icon: <Vendororder />,
    },
    {
      url: "/task",
      roleName: "Manage Tasks",
      icon: <PrintSvg />,
    },

    {
      url: "/activitylog",
      roleName: "Activity Logs",
      icon: <ReportTaxReport />,
    },
    // 🔥 NEW SUB MENU
    {
      roleName: "Manage Data",
      icon: <AdminSettingsSvg />,
      children: [
        {
          url: "/empolyee",
          roleName: "Manage Employees",
          icon: <Contractsvg />,
        },
        {
          url: "/client",
          roleName: "Manage Clients",
          icon: <ReportReciptSvg />,
        },
        {
          url: "/department",
          roleName: "Manage Departments",
          icon: <Manageapplication />,
        },
        {
          url: "/technology",
          roleName: "Manage Technologies",
          icon: <Manageroletab />,
        },
      ],
    },
    {
      roleName: "HR Department",
      icon: <Manageapplication />,
      children: [
        {
          url: "/hr-projects",
          roleName: "HR Activities",
          icon: <Vendororder />,
        },
        {
          url: "/hr-task",
          roleName: "HR Tasks",
          icon: <PrintSvg />,
        },
        {
          url: "/hr-leave",
          roleName: "Leaves",
          icon: <LeaveManagement />,
        },
        {
          url: "/hr-document",
          roleName: "Documents",
          icon: <PrintSvg />,
        },
      ],
    },
    {
      roleName: "Reports",
      icon: <ReportsSvg />,
      children: [
        {
          url: "/hourly-report",
          roleName: "Hourly Report",
          icon: <HourlySvg />,
        },
        {
          url: "/financial-report",
          roleName: "Finance Report",
          icon: <FinecialSvg />,
        },
      ],
    },

    // {
    //   url: "/estimation",
    //   roleName: "Manage Estimations",
    //   icon: <ReportOrderReport />,
    // },

    {
      url: "/notification",
      roleName: "Notifications",
      icon: <NotificationSvg />,
    },
    {
      url: "/note",
      roleName: "My Notes",
      icon: <NoteSvg />,
    },
  ];

  const hr_links = [
    {
      url: "/hourly-report",
      roleName: "Hourly Report",
      icon: <HourlySvg />,
    },
    {
      url: "/activitylog",
      roleName: "Activity Logs",
      icon: <ReportTaxReport />,
    },
    {
      url: "/hr-projects",
      roleName: "My Activities",
      icon: <Vendororder />,
    },
    
    {
      url: "/hr-task",
      roleName: "My Tasks",
      icon: <PrintSvg />,
    },
    {
      url: "/hr-document",
      roleName: "Documents Management",
      icon: <PrintSvg />,
    },
     {
      url: "/hr-leave",
      roleName: "Leaves",
      icon: <LeaveManagement />,
    },
    {
      url: "/note",
      roleName: "My Notes",
      icon: <NoteSvg />,
    },
    {
      url: "/notification",
      roleName: "Notifications",
      icon: <NotificationSvg />,
    },
    {
      url: "/support",
      roleName: "Hardware Support",
      icon: <SuportSvg />,
    },
   
  ];

  useEffect(() => {
    if (user?.role === "Super Admin") {
      setLinks(admin_links);
    } else if (user?.role === "Manager") {
      setLinks(manager_links);
    } else if (user?.role === "Admin (Manager)") {
      setLinks(adminmanager_links);
    } else if (user?.role === "HR") {
      setLinks(hr_links);
    } else {
      setLinks(member_links);
    }
    // eslint-disable-next-line
  }, []);

  const handleClosemenu = () => {
    setShow("");
  };

  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShow(""); // Hide the menu
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const activeParent = links.find(
      (item) =>
        item.children &&
        item.children.some((child) => location.pathname.startsWith(child.url)),
    );

    if (activeParent) {
      setOpenMenu(activeParent.roleName);
    } else {
      setOpenMenu("");
    }
  }, [location.pathname, links]);

  return (
    <>
      <div className="intersight_menu" ref={menuRef}>
        <div className="top_menu">
          {/*Start Logo Dropdown*/}
          <div className="brand">
            <button
              className="navbar-toggler navbar-toggle"
              type="button"
              onClick={() => setShow((prev) => (prev === "show" ? "" : "show"))}
            >
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
            <div className="dropdown">
              <button
                className="border-0 w-100 d-flex align-items-center"
                type="button"
              >
                <span
                  className="d-flex align-items-center justify-content-center"
                  style={{ overflow: "hidden" }}
                >
                  <img src="/image/BT-logo 2.png" alt="" loading="lazy" />
                </span>{" "}
                Brain Technosys PMS
              </button>
            </div>
          </div>

          {/*End Logo Dropdown*/}
          {/*Start Menu*/}
          <div className={`intersight_home ${show}`}>
            <div className="menu_div">
              <ul>
                <li onClick={() => setShow("")}>
                  <NavLink
                    to="/dashboard"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <span>
                      <Dashboardsvg />
                    </span>
                    Dashboard
                  </NavLink>
                </li>
                <li className="without_label">Workspace</li>
              </ul>
              <ul className="menu_scrollbar">
                {links?.map((item, i) => {
                  const hasChildren = item.children;
                  const isOpen = openMenu === item.roleName;

                  if (hasChildren) {
                    return (
                      <li key={i} className={`submenu ${isOpen ? "open" : ""}`}>
                        <div
                          className="submenu-title"
                          onClick={() =>
                            setOpenMenu((prev) =>
                              prev === item.roleName ? "" : item.roleName,
                            )
                          }
                        >
                          <span className="submenu-left">
                            {item.icon}
                            {item.roleName}
                          </span>

                          <span className="submenu-arrow">
                            {" "}
                            <ChevronDown />
                          </span>
                        </div>

                        <ul className="submenu-list">
                          {item.children.map((child, idx) => (
                            <SideBarLink
                              key={idx}
                              href={child.url}
                              name={child.roleName}
                              icon={child.icon}
                              handleClosemenu={handleClosemenu}
                            />
                          ))}
                        </ul>
                      </li>
                    );
                  }

                  return (
                    <SideBarLink
                      key={i}
                      href={item.url}
                      name={item.roleName}
                      icon={item.icon}
                      handleClosemenu={handleClosemenu}
                    />
                  );
                })}
              </ul>

              {/* <div className="bottom_menu">
                {user?.role !== "Super Admin"  ? (
                  <p className=""> */}
              {/* <Link to="/support" className="d-block text-decoration-underline">
                     Hardware Support
                    </Link> */}
              {/* </p>
                ) : (
                  <p></p>
                )} */}
              {/* <div className="user_person">
                  <div className="dropdown">
                    <button
                      className="dropdown-toggle border-0 w-100 d-flex align-items-center p-0"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <span className="d-flex align-items-center justify-content-center person_icon">
                        <img
                          src={
                            users?.image_url
                              ? users?.image_url
                              : user?.image_url
                          }
                          alt=""
                          loading="lazy"
                        />
                      </span>
                      <label className="person_name">
                        {users?.name ? users?.name : user?.name}{" "}
                        <span className="d-block">
                          {users?.email ? users?.email : user?.email}
                        </span>
                      </label>
                    </button>
                    <ul className="dropdown-menu w-100">
                      <li onClick={() => setShow("")}>
                        <Link className="dropdown-item" to="/update-profile">
                          My Profile
                        </Link>
                      </li>
                      <li onClick={() => setShow("")}>
                        <Link className="dropdown-item" to="/chnage-password">
                          Change Password
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="#"
                          onClick={() => setOpen(true)}
                        >
                          Logout
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
          {/*End Start Menu*/}
        </div>
      </div>
      <Logout open={open} handleClose={handleClose} />
    </>
  );
}
